import { atom } from 'recoil';

import { ATOMS } from './constants';

export type SendEmailSession = {
  /** Identifies the record a draft belongs to; same key = same draft. */
  key: string;
  relatedEntityType: string;
  relatedRecordId?: string;
  recipientId?: string;
  recipientEmail: string;
  /** Shown on the minimized pill; falls back to recipientEmail. */
  recordLabel?: string;
};

export type SendEmailState = {
  session: SendEmailSession | null;
  minimized: boolean;
  /** Session waiting for the user to confirm discarding the current draft. */
  pending: SendEmailSession | null;
};

export const defaultSendEmailState: SendEmailState = {
  session: null,
  minimized: false,
  pending: null
};

export const sendEmailStateAtom = atom<SendEmailState>({
  key: ATOMS.SEND_EMAIL_SESSION_ATOM,
  default: defaultSendEmailState
});
